import React from "react"
import {
  VStack,
} from "@chakra-ui/react"
import { BadgeTemplate } from "sharedTypes/badge"
import Button from "components/Buttons/Button"
import { downloadBlob } from "utilities/fileDownload"
import EditorPane from "components/CanvasEditor/EditorPane"

type Props = {
  template?: BadgeTemplate
}

const DevControls = ({ template }: Props) => {
  const handleDownloadEditorState = () => {
    if (!template) return

    const editorState = {
      badgeData: template.badgeData,
      widthMm: template.widthMm,
      heightMm: template.heightMm,
      printerModel: template.printerModel,
      printerMedia: template.printerMedia,
      printerOrientation: template.printerOrientation,
    }

    downloadBlob(JSON.stringify(editorState, null, 2), `${template.name}-editor-state.json`, "application/json")
  }

  const handleDownloadFullBadge = () => {
    if (!template) return

    downloadBlob(JSON.stringify(template, null, 2), `${template.name}-full-badge.json`, "application/json")
  }

  const handleDownloadManifest = () => {
    if (!template) return

    downloadBlob(JSON.stringify(template.manifest, null, 2), `${template.name}-manifest.json`, "application/json")
  }

  const handleDownloadHtml = () => {
    if (!template) return

    downloadBlob(template.html, `${template.name}.html`, "text/html")
  }

  if (!template) {
    return null
  }

  return (
    <EditorPane title="Dev Tools">
      <VStack spacing={2} align="stretch">
        <Button
          size="sm"
          onClick={handleDownloadFullBadge}
          fontSize="sm"
          variant="outline"
          colorScheme="blue"
        >
          DB Full Badge Object
        </Button>

        <Button
          size="sm"
          onClick={handleDownloadHtml}
          fontSize="sm"
          variant="outline"
          colorScheme="blue"
        >
          DB HTML
        </Button>

        <Button
          size="sm"
          onClick={handleDownloadManifest}
          fontSize="sm"
          variant="outline"
          colorScheme="blue"
        >
          DB Manifest
        </Button>

        <Button
          size="sm"
          onClick={handleDownloadEditorState}
          fontSize="sm"
        >
          Current Editor State (JSON)
        </Button>
      </VStack>
    </EditorPane>
  )
}

export default DevControls
